import { saveAs } from "file-saver";
import urlConfig from "../url";
import HTTP from "../../utils/http";
import { resolve } from "tinymce";
import { Message } from "element-ui";
// 下载文件方法
export function FunDownload(content, filename = "") {
  console.log("下载地址", content);
  if (filename) {
    saveAs(content, filename);
  } else {
    saveAs(content);
  }
}

/**
 * 上传导入文件
 * @param {String} uploadUrl 上传地址
 * @param {Object} options  可能要携带的
 */

export function ExportFn(uploadUrl, options = {}) {
  return new Promise((resolve, reject) => {
    var btn = document.createElement("input");
    btn.type = "file";
    btn.onchange = (result) =>
      uploadFile(result, uploadUrl, options)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    document.body.appendChild(btn);
    btn.click();
  });
}

function uploadFile(res, url, options) {
  return new Promise((resolve, reject) => {
    let files = res.target.files;
    var formData = new FormData();
    formData.append("file", files[0]);
    Object.entries(options).forEach((el) => {
      formData.append(el[0], el[1]);
    });
    console.log('formData', formData)
    HTTP.axios({
      url: url,
      method: "post",
      data: formData,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        // "Admin-Token": url.includes('http://192.168.10.220:5082') ? 'Bearer test17' : ''
      },
    })
      .then((res) => {
        resolve(res.data);
      })
      .catch((error) => {
        reject(error.data);
      });
  });
}

// 根据秒 转换为 具体时间
export function FormatSeconds(value) {
  var secondTime = parseInt(value); // 秒
  var minuteTime = 0; // 分
  var hourTime = 0; // 小时
  if (secondTime > 60) {
    //如果秒数大于60，将秒数转换成整数
    //获取分钟，除以60取整数，得到整数分钟
    minuteTime = parseInt(secondTime / 60);
    //获取秒数，秒数取佘，得到整数秒数
    secondTime = parseInt(secondTime % 60);
    //如果分钟大于60，将分钟转换成小时
    if (minuteTime > 60) {
      //获取小时，获取分钟除以60，得到整数小时
      hourTime = parseInt(minuteTime / 60);
      //获取小时后取佘的分，获取分钟除以60取佘的分
      minuteTime = parseInt(minuteTime % 60);
    }
  }
  var result = "" + parseInt(secondTime) + "秒";

  if (minuteTime > 0) {
    result = "" + parseInt(minuteTime) + "分" + result;
  }
  if (hourTime > 0) {
    result = "" + parseInt(hourTime) + "小时" + result;
  }
  return result;
}

/**
 *  根据url  获取文件名
 * @param {*} url
 */
export function GetUrlName(url) {
  let arr = url?.split("__!");
  return arr[arr.length - 1];
}

// 禁用今日以后时间
export function DisabledDateFn(date) {
  let ndate = new Date(date).valueOf();
  // console.log(ndate)
  if (ndate >= new Date().valueOf() + 1000 * 10 ) {
    return true;
  } else {
    return false;
  }
}
// 禁用今日之前时间
export function DisabledDateFn1(date) {
  let ndate = new Date(date).valueOf();
  // console.log(ndate)
  if (ndate <= new Date().valueOf() + 1000 * 10 - 24 * 60 * 60 * 1000 ) {
    return true;
  } else {
    return false;
  }
}

/**
 * 发送站内消息
 * @param {Object} object
 * @param {string} object.title  标题
 * @param {number} object.user_id  用户id
 * @param {string} object.message  主要信息
 */
export async function SendSiteMessage({ title, user_id, message }) {
  return new Promise((resolve) => {
    HTTP.post("Mail", {
      user_id: user_id,
      message: message,
      title: title,
      send_time: new Date().format("yyyy-MM-dd hh:mm:ss"),
    })
      .then((res) => {
        if (res.code == 0) {
          resolve({ url: "Mail", flag: true, error: "" });
        }
      })
      .catch((err) => {
        resolve({ url: "Mail", flag: false, error: err });
      });
  });
}

// 发送短信验证码
export function SendMessage({ content, phone }) {
  return new Promise((resolve) => {
    HTTP.post("code/common_send", {
      content: content,
      phone: phone,
    })
      .then((res) => {
        console.log("发送结果", res);
        if (res.errmsg === "OK") {
          resolve({ url: "code/common_send", flag: true, error: "" });
        } else {
          resolve({ url: "code/common_send", flag: false, error: res });
        }
      })
      .catch((err) => {
        resolve({ url: "code/common_send", flag: false, error: err });
      });
  });
}
/**
 * 参数 升序传入  start_time --> end_time --> expire_time
 */
export const CheckTimeLine = (...rest) => {
  const list = [...rest];
  let flag = false;
  for (let i = 0; i < list.length - 1; i++) {
    if (new Date(rest[i]) > new Date(rest[i + 1])) {
      flag = true;
      Message.warning("请注意 时间选择是否正确");
      return flag;
    }
  }
  return flag;
};

/**
 * 富文本标签替换
 * @param {*} str
 */
export function GetTarg(str) {
  let res = str?.replace(/\<\/?.*?\>|\&nbsp\;/g, "");
  res = res?.replace(/\&ldquo;/g, "“");
  res = res?.replace(/\&rdquo;/g, "”");
  res = res?.replace(/\&lt;/g, "<");
  res = res?.replace(/\&gt;/g, ">");
  return res;
}

/**
 * 解析上传文件名
 * @param {*} str
 */
export function GetFileName(str) {
  const arr = str.split("__!");

  return arr[arr.length - 1];
}

/**
 *  elementui 校验地址插件
 * @param {*} rule
 * @param {*} value
 * @param {*} callback
 */
export function CheckAddress(rule, value, callback) {
  console.log("检验函数结果00", rule);
  console.log("检验函数结果01", value);
  callback(callback(new Error("请设置推荐度")));
}


/***
 * 
 * 解决可能存在的bug
 * @param {string} templateUrl 文件服务器域名
 * @param {string} url  接口返回的当前地址
 * 
 */

export function GetDownUrl(templateUrl= '',url = '') {
  if (url.search(templateUrl) !== -1) {
    return url.substr(templateUrl.length - url.length);
  } else {
    return url;
  }
}

// zip 下载
export async function DownLoadUrl(url, name) {
  console.log("测试地址", url);
  saveAs(url);
}